export const labelCropYieldGoal =
    {
        "labelYieldGoal": {
            "en": "Yield Goal",
            "es": "Rendimiento Objetivo",
            "fr": "Rendement objectif",
            "pt": "Produtividade almejada",
            "ru": "Планируемая урожайность",
            "zh": "目标产量"
        }
    };
